// Due dates on issues are DAY-precision values: the browser sends a bare
// "YYYY-MM-DD" (an <input type="date"> value) and the server stores that
// day's UTC midnight (`new Date("2026-09-01")`). Reading one back through
// plain `moment(...)` renders it in the browser's zone, which shows the
// PREVIOUS day for anyone west of Greenwich — so every read of dueDate
// goes through moment.utc() here instead.
import moment from "moment";

// Value for an <input type="date">; "" when there is no due date.
export const dueInputValue = (v) => (v ? moment.utc(v).format("YYYY-MM-DD") : "");

export const formatDue = (v, fmt = "MMM D, YYYY") => (v ? moment.utc(v).format(fmt) : "");

// Overdue only once the whole due DAY has gone by — an issue due today is
// not late at 9am.
export const isPastDue = (v) => !!v && moment.utc(v).endOf("day").isBefore(moment());

// Whole days from now to the end of the due day: 0 = today, 1 = tomorrow,
// negative = that many days late. null when there is no due date.
export const daysToDue = (v) =>
  (v ? moment.utc(v).endOf("day").diff(moment(), "days") : null);

// Short chip text for the board / grouped rows: "Today", "Tomorrow",
// "in 4d", "3d late", or the date itself once it is further out.
export const dueChipLabel = (v) => {
  if (!v) return "";
  const d = daysToDue(v);
  if (d < 0) return `${Math.abs(d)}d late`;
  if (d === 0) return "Today";
  if (d === 1) return "Tomorrow";
  if (d <= 7) return `in ${d}d`;
  return formatDue(v, "MMM D");
};
